import { Fragment } from 'react';
import { getRandomUid } from 'utilities/uuid.service';

function TextArea({ id, label = 'Text area label', areaProps = {} }) {
  const textAreaID = id ?? getRandomUid();

  return (
    <Fragment>
      <label htmlFor={textAreaID}>{label}</label>
      <textarea id={textAreaID} cols="20" {...areaProps}></textarea>
    </Fragment>
  );
}

export default TextArea;
